import { FadeUp, MaskedLines } from "@/components/Reveal";
import { IMG } from "@/data/site";

const LINES = ["Perfect light.", "Perfect balance.", "Perfect atmosphere.", "Perfect timing."];

export default function Philosophy() {
  return (
    <section data-testid="philosophy-section" className="relative py-36 md:py-52 overflow-hidden">
      <img
        src={IMG.archMinimal}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-[0.14]"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/70 to-ink" />

      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12">
        <h2 className="font-display font-light text-4xl md:text-6xl lg:text-[5.5vw] leading-[1.02] tracking-tight max-w-5xl">
          <MaskedLines
            lines={[
              "WE DON\u2019T EDIT TO IMPRESS.",
              <>
                WE EDIT TO <em className="text-gold italic">FEEL REAL.</em>
              </>,
            ]}
          />
        </h2>
        <FadeUp delay={0.3} className="mt-12 max-w-xl">
          <p className="text-sm md:text-base text-ivory/70 font-light leading-relaxed">
            Luxury editing should never look like editing. It should look like —
          </p>
        </FadeUp>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-ivory/10 border hairline max-w-4xl">
          {LINES.map((l, i) => (
            <FadeUp key={l} delay={0.1 * i} className="bg-ink">
              <div className="px-6 py-8">
                <span className="block w-6 h-px bg-gold mb-4" />
                <span className="font-display italic text-xl md:text-2xl text-ivory/90">{l}</span>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
